import repository from './repository'

const resource = 'imports'

export default {
  pos (data) {
    return repository.post(`${resource}/pos`, data)
  },
}
